module.exports = __webpack_public_path__ + "img/pin_take_away_red.b5ff8f11.svg";